import { atom } from 'recoil';

const selectedMenuId = atom<string | null>({
  key: 'selectedMenuId',
  default: null,
});

export default selectedMenuId;
